import { Outlet } from 'react-router-dom';
import { useSelector } from 'src/store';
import Status401 from 'src/content/pages/Status/Status401';
import { isUserInactive } from 'src/slices/auth/authAction';

const RoleBasedRoute = ({ rolesCustom, element }) => {
  const { roles, isMultiproducer, selectedProducer, profile } = useSelector((state) => state.auth);
  if (profile && isUserInactive(profile)) {
    return <Status401 />;
  }

  const rolesList = Array.isArray(roles) ? roles : [];

  const selectedProducerId =
    selectedProducer && selectedProducer.id !== undefined && selectedProducer.id !== null
      ? selectedProducer.id.toString()
      : null;

  const rolesForEvaluation = isMultiproducer
    ? rolesList.filter((role) => {
        const producers = Array.isArray(role.producerId) ? role.producerId : [];

        // Roles sin productoras asociadas se consideran globales
        if (producers.length === 0) {
          return true;
        }

        if (!selectedProducerId) {
          return false;
        }

        return producers.some((producer) => {
          if (!producer || producer.id === undefined || producer.id === null) {
            return false;
          }

          return producer.id.toString() === selectedProducerId;
        });
      })
    : rolesList;

  if (rolesForEvaluation.some((role) => rolesCustom.includes(role.id))) {
    return element || <Outlet />;
  } else {
    return <Status401 />;
  }
};

export default RoleBasedRoute;
